import { Button } from "@mui/material";

import { className } from "utils/strings";

import { ReactComponent as ActiveIcon } from "components/icons/FooterIcons/bookmarkIconActive.svg";
import { ReactComponent as InActiveIcon } from "components/icons/FooterIcons/bookmarkIconInactive.svg";

import "./buttons.scss";
import { showAuthModal } from "store/application/application-action";
import { useDispatch } from "react-redux";

export const SavedButton = (props: {
  active: boolean;
  username: string|null;
  onClick: () => void;
}): JSX.Element => {
  const dispatch = useDispatch();

  const Icon = props.active
    ? ActiveIcon
    : InActiveIcon;

  const onClick = () => {
    if (props.username) {
      props.onClick();
    } else {
      dispatch(showAuthModal());
    }
  };

  return (
    <Button onClick={onClick} className={className({
      "saved": true,
      "active": props.active,
      "inactive": !props.active,
    })}>
      <Icon />
      <label>Saved</label>
    </Button>
  );
};
